<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-card>
      <v-form ref="form" lazy-validation>
        <v-tabs v-model="tab">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="item in items" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(item, i) in items" :key="item">
            <v-data-table
              :headers="headers"
              :items="i === 0 ? vehicles : inactive"
              sort-by="Name"
              sort-asc
              class="elevation-1"
              :loading="isLoading"
              loading-text="Loading Vehicles"
              :search="search"
              height="600"
            >
              <!-- <template v-slot:item.select="{ item }">
          <router-link
            :to="{
              name: 'ClientInfo',
              params: { clientID: item._id },
            }"
          >
            <v-btn x-small color="#2b3990" class="white--text">
              select
            </v-btn>
          </router-link>
        </template> -->

              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Vehicles</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="search"
                    label="search"
                    class="desktop"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-dialog
                    v-model="dialog"
                    max-width="100%"
                    :retain-focus="false"
                  >
                    <template v-slot:activator="{ on }" v-if="showButton">
                      <v-btn
                        color="#2b3990"
                        class="mb-2 white--text"
                        v-on="on"
                        @click="showAdd()"
                      >
                        <v-icon left>add</v-icon>
                        Add Vehicle</v-btn
                      >
                      <!-- <v-btn
                  v-if="isAdmin"
                  color="success"
                  class="mb-2 white--text mr-2"
                  @click="download()"
                >
                  <v-icon left>mdi-download</v-icon>
                  export csv</v-btn
                > -->
                    </template>
                    <v-card>
                      <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{
                          titleForm
                        }}</span>
                      </v-card-title>
                      <v-card-text>
                        <validation-observer ref="observer">
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="12" md="4">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Make"
                                  rules="required"
                                >
                                  <v-text-field
                                    v-model="newMake"
                                    label="Make"
                                    :error-messages="errors"
                                  ></v-text-field>
                                </validation-provider>
                              </v-col>

                              <v-col cols="12" sm="12" md="4">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Model"
                                  rules="required"
                                >
                                  <v-text-field
                                    v-model="newModel"
                                    label="Model"
                                    :error-messages="errors"
                                  ></v-text-field>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" sm="12" md="4">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Year"
                                  rules="required"
                                >
                                  <v-text-field
                                    v-model="newYear"
                                    label="Year"
                                    :error-messages="errors"
                                  ></v-text-field>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" sm="12">
                                <validation-provider
                                  v-slot="{ errors }"
                                  name="Color"
                                  rules="required"
                                >
                                  <v-text-field
                                    v-model="newColor"
                                    label="Color"
                                    :error-messages="errors"
                                  ></v-text-field>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" sm="12" md="6">
                                <v-select
                                  :items="states"
                                  v-model="newState"
                                  label="State"
                                  :rules="requiredField"
                                ></v-select>
                              </v-col>

                              <v-col cols="12" sm="12" md="6">
                                <v-select
                                  :items="status"
                                  v-model="newStatus"
                                  label="Status"
                                  :rules="requiredField"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-container>
                        </validation-observer>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="white--text"
                          color="#259647"
                          @click="onAddVehicle(newVehicle)"
                          v-if="newVehicle"
                          >Save</v-btn
                        >
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="updateVehicle()"
                          v-if="editVehicle"
                          >Update</v-btn
                        >
                        <v-btn color="blue darken-1" text @click="close"
                          >Cancel</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="mobile ml-5 mr-5 mb-3 mt-3"
                ></v-text-field>
              </template>

              <template
                v-slot:item.actions="{ item }"
                class="align-self-center"
              >
                <v-icon small class="mr-2" @click="viewVehicle(item)">
                  mdi-eye
                </v-icon>
                <v-icon small @click="deleteVehicle(item)"  v-if="showButton">
                  mdi-delete
                </v-icon>
                <!-- <v-icon small class="mr-2" @click="editClient(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteClient(item)" v-if="showButton">
            mdi-delete
          </v-icon> -->
                <!-- <v-icon small @click="addDeal(item)">
            add
          </v-icon> -->
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="#2b3990"
                  class="white--text"
                  @click="getVehicles()"
                  >Reset</v-btn
                >
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-form>
    </v-card>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import Foot from "../components/Footer";
import { mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const url = require("../client_config/config").url;

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Foot,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Make",
          value: "Make",
          align: "start",
          sortable: true,
        },
        { text: "Model", value: "Model" },
        { text: "Year", value: "Year" },
        { text: "Status", value: "Status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialog: false,
      tab: null,
      items: ["Active Vehicles", "Inactive Vehicles"],
      editVehicle: false,
      newVehicle: false,
      msg: false,
      search: "",
      text: "",
      vehicles: [],
      inactive: [],
      states: ["Utah", "Nevada"],
      status: ["Active", "Inactive"],
      companyID: localStorage.getItem("companyID"),
      titleForm: "New Vehicle",
      newMake: "",
      newModel: "",
      newYear: "",
      newStatus: "",
      vehicleID: "",
      showButton: false,
      newColor: "",
      newState: "",
      requiredField: [(v) => !!v || "This is required"],
      userState: localStorage.getItem("userState"),
      userRole: localStorage.getItem("userRole"),
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    isAdmin() {
      let roles = [
        "Administration",
        "Human Resources",
        "Compliance Manager",
        "Client Services Manager",
        "Medical Manager",
        "SuperAdministrator",
      ];
      return roles.includes(localStorage.getItem("userRole"));
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.showAction();
    this.getVehicles();
  },

  methods: {
    ...mapActions({
      downloadCSV: "clients/downloadCSV",
    }),

    initialize() {
      this.vehicles = [];
    },
    validate() {
      return this.$refs.form.validate();
    },
    validateReset() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.reset();
      }
    },
    viewVehicle(item) {
      this.titleForm = "Viewing " + item.Make + " " + item.Model;
      this.dialog = true;
      this.editVehicle = true;
      this.newVehicle = false;
      this.newMake = item.Make;
      this.newModel = item.Model;
      this.newYear = item.Year;
      this.newState = item.State;
      this.newStatus = item.Status;
      this.vehicleID = item._id;
    },
    showAdd() {
      this.titleForm = "New Vehicle";
      this.newVehicle = true;
      this.editVehicle = false;
    },

    deleteVehicle(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this vehicle?") &&
        this.vehicleDelete(id);
    },

    vehicleDelete(id) {
      axios.delete(`${url}/vehicles/${id}`).then((response) => {
        this.getVehicles();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The vehicle has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });

      this.clear();
    },

    updateVehicle() {
      var req_body = {
        Make: this.newMake,
        Model: this.newModel,
        Year: this.newYear,
        State: this.newState,
        Status: this.newStatus,
      };
      axios
        .put(`${url}/vehicles/${this.vehicleID}`, req_body)
        .then((response) => {
          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          this.getVehicles();
          this.msg = true;
          this.text = "The vehicle has been updated successfully.";
          this.close();
        });
    },

    async onAddVehicle(context) {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        context ? this.addVehicle() : this.updateVehicle();
        this.clear();
        return;
      } else {
        this.msg = true;
        this.text = "Please fill out all required fields";
      }
    },

    async addVehicle() {
      var req_body = {
        Make: this.newMake,
        Model: this.newModel,
        Year: this.newYear,
        State: this.newState,
        Status: this.newStatus,
      };

      axios.post(`${url}/vehicles`, req_body).then((res) => {
        this.getVehicles();
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.msg = true;
        this.text = "The new vehicle has been added successfully.";
      });
      this.isLoading = true;
      this.close();
    },

    getVehicles() {
      this.isLoading = true;

      axios.get(`${url}/vehicles/${this.userState}`).then((res) => {
        var temp = res.data.vehicles;
        this.vehicles = [];
        this.inactive = [];
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].Status == "Inactive") {
            this.inactive.push(temp[i]);
          } else {
            this.vehicles.push(temp[i]);
          }
        }
        this.isLoading = false;
      });
    },

    async download() {
      try {
        const response = await this.downloadCSV();
        if (response.success) {
          var FileSaver = require("file-saver");
          const blob = new Blob([response.data], { type: "text/csv" });
          FileSaver.saveAs(blob, response.filename);
          return;
        }
        this.msg = true;
        this.text = response.message;
      } catch (error) {
        console.log(error);
        this.msg = true;
        this.text = "An Error Occured";
      }
    },

    clear() {
      this.newMake = "";
      this.newModel = "";
      this.newYear = "";
      this.newState = "";
      this.newStatus = "";

      // this.$refs.observer.reset();
    },

    showAction() {
      if (
        this.userRole == "Program Coordinator" ||
        this.userRole == "Client Services Manager" ||
        this.userRole == "Administration" ||
        this.userRole == "Human Resources" ||
        this.userRole == "Compliance Manager" ||
        this.userRole == "SuperAdministrator"
      ) {
        this.showButton = true;
      }
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
